import { Component, ChangeDetectionStrategy } from '@angular/core';

import { CtaButtonComponent } from '@app/common/components/cta-button/cta-button.component';

@Component({
  selector: 'app-mobile-bar',
  imports: [CtaButtonComponent],
  templateUrl: './mobile-bar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mobile-bar.component.scss'
})
export class MobileBarComponent {}
